import React, { useState, useEffect, useRef } from "react";
import FirstButton from "../common/button";
import { useSearchParams } from "react-router-dom";
import api from "../Axios";
import { toast } from "react-toastify";
import login from "../assets/images/login-1.jpeg";

const VerifyOtp = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const inputRefs = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (pasted.length === 6) {
      setOtp(pasted.split(""));
      inputRefs.current[5]?.focus();
    }
  };

  const handleSubmit = () => {
    const otpStr = otp.join("");
    if (otpStr.length !== 6) {
      toast.error("Please enter the 6-digit OTP");
      return;
    }
    setLoading(true);
    api
      .post("verify-otp", { email, otp: otpStr })
      .then((resp) => {
        toast.success(resp.data.message);
        setResult(resp.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Verification failed");
      })
      .finally(() => setLoading(false));
  };

  const handleResend = () => {
    api
      .post("resend-otp", { email })
      .then((resp) => {
        toast.success(resp.data.message);
        setOtp(["", "", "", "", "", ""]);
        inputRefs.current[0]?.focus();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to resend OTP");
      });
  };

  return (
    <div className="login_main">
      <div
        className="only-d-flex about-class justify-between"
        style={{ height: "90vh" }}
      >
        <div
          className="w50 px-4 py-4 login-card-color text-white image-display-none"
          style={{
            backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0) 80%), url(${login})`,
            backgroundSize: "cover",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="login_heading text-white mb-4">
              Verify Your Email
            </div>
            <p className="fs-20 fw-600 mb-4 mx-4">
              We've sent a verification code to your email address.
              <br /> Please enter the code below to continue.
            </p>
          </div>
        </div>

        <div
          className="w50 px-4 py-4"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {result ? (
            <div className="login_body">
              <div className="fs-20 fw-600 mb-4">
                {result.approved
                  ? "Email verified! Check your email for the registration link."
                  : "Email verified! Your account is pending admin approval. You'll receive a registration link once approved."}
              </div>
            </div>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="login_body">
                <div className="fs-20 fw-600 mb-4">
                  Enter the 6-digit code sent to{" "}
                  <strong>{email}</strong>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    margin: "20px 0",
                  }}
                >
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={index === 0 ? handlePaste : undefined}
                      style={{
                        width: "50px",
                        height: "55px",
                        textAlign: "center",
                        fontSize: "24px",
                        fontWeight: "bold",
                        border: "2px solid #ccc",
                        borderRadius: "8px",
                        outline: "none",
                      }}
                    />
                  ))}
                </div>
                <FirstButton
                  className="btn"
                  buttonText={loading ? "Verifying..." : "Verify"}
                  type="submit"
                  marginTop="2rem"
                  width="40%"
                />
                <p className="login_last_para">
                  Didn't receive the code?{" "}
                  <span
                    className="login_link"
                    style={{ cursor: "pointer" }}
                    onClick={handleResend}
                  >
                    Resend OTP
                  </span>
                </p>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
